export default __webpack_public_path__ + "static/media/Promptopia.c7b525ed.png";